import { PstShortDatePresenter } from '@omaze/omaze-present';
import { CSSProperties } from 'react';

import { OzDate } from '../../../../../../shared/OzDate/OzDate';
import styles from '../Winner.styles.css';

export interface IWinnerPresenterConfig {
    projectedWinnerAnnounceDate: Date;
    confirmedWinnerAnnounceDate: Date | undefined;
    backgroundImage: string;
    image: string;
}

export interface IWinnerPresenterClassNames {
    backgroundImage: string;
    winnerContent: string;
    header: string;
    winnerName: string;
    winnerLocation: string;
    winnerDate: string;
    winnerImageContainer: string;
    winnerImage: string;
}

export class WinnerPresenter {
    protected projectedWinnerAnnounceDate: Date;
    protected confirmedWinnerAnnounceDate: Date | undefined;
    protected backgroundImage: string;
    protected winnerImage: string;

    public constructor (winnerPresenterConfig: IWinnerPresenterConfig) {
        this.projectedWinnerAnnounceDate = winnerPresenterConfig.projectedWinnerAnnounceDate;
        this.confirmedWinnerAnnounceDate = winnerPresenterConfig.confirmedWinnerAnnounceDate;
        this.backgroundImage = winnerPresenterConfig.backgroundImage;
        this.winnerImage = winnerPresenterConfig.image;
    }

    public getAllClassNames (): IWinnerPresenterClassNames {
        return {
            backgroundImage: 'relative pt-1 pl-3 pr-3 pb-2 bg-navy-50 z-10',
            winnerContent: styles.winnerContent,
            header: 'font-gellix text-2xl font-bold text-gray-900',
            winnerName: 'mt-1 mb-1/2 text-base font-gellix uppercase break-all text-gray-900 font-bold',
            winnerLocation: 'break-all font-gellix text-sm mb-1/2 not-italic text-gray-900 font-medium',
            winnerDate: 'font-gellix text-xs italic mb-1/2 text-gray-900',
            winnerImageContainer: 'absolute top-5 right-3 bg-transparent',
            winnerImage: `${styles.winnerImage} rounded-full bg-cover bg-no-repeat bg-center`,
        };
    }

    public getAnnouncedText (): string {
        // TODO: Utilize strictly the confirmedWinnerAnnounceDate when all campaigns, that don't have this field, have
        //  expired or have been back-filled to have a confirmedWinnerAnnounceDate.
        const datePresenter: PstShortDatePresenter = new PstShortDatePresenter();

        if (this.confirmedWinnerAnnounceDate !== undefined) {
            return `Announced ${datePresenter.present(this.confirmedWinnerAnnounceDate)}`;
        }

        if (OzDate.isDateValid(this.projectedWinnerAnnounceDate)) {
            return `Announced ${datePresenter.present(this.projectedWinnerAnnounceDate)}`;
        }

        return '';
    }

    public getWinnerContainerStyles (): CSSProperties {
        return {
            background: 'linear-gradient(269.88deg, #FFF3F2 0.1%, #FFFCF8 99.9%)',
        };
    }

    public getWinnerImageStyles (): CSSProperties {
        return {
            backgroundImage: `url('${this.winnerImage}')`,
        };
    }
}
